<template>
  <div class="login-form">
    <div class="login-form-l">
      <div class="tip">打开<span>电子税务局APP</span>扫一扫</div>
      <div class="qrcode">
        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-03-06/1741228140205_tax-1.png" />
      </div>
      <div class="btn">
        <el-button type="primary" round>电子税务局APP</el-button>
        <el-button round>个人所得税APP</el-button>
      </div>
    </div>
    <div class="login-form-r">
      <ul class="tab">
        <li v-for="(item, index) of loginTypeOptions" @click="loginTypeChange(item)"
            :class="{ 'is-active': item.value == formData.loginType }" :key="index">{{ item.label }}</li>
      </ul>

      <el-form :model="formData" class="form-box" ref="formRef" @keyup.enter="login">
        <el-form-item prop="taxRegistrationNo" v-if="formData.loginType == 1" :rules="[{ required: true, message: '请输入统一社会信用代码/纳税人识别号', trigger: 'change' }]">
          <el-input v-model.trim="formData.taxRegistrationNo"
                    disabled
                    placeholder="统一社会信用代码/纳税人识别码" size="large" prefix-icon="Postcard" />
        </el-form-item>

        <el-form-item prop="taxRegistrationNo" v-if="formData.loginType == 3" :rules="[{ required: true, message: '请输入统一社会信用代码/纳税人识别号', trigger: 'change' }]">
          <el-input v-model.trim="formData.taxRegistrationNo"
                    disabled
                    placeholder="代理机构统一社会信用代码/纳税人识别号" size="large" prefix-icon="Postcard" />
        </el-form-item>

        <el-form-item prop="phone" :rules="[{ required: true, message: '请输入居民身份证号码/手机号码/用户名', trigger: 'change' }]">
          <el-input v-model.trim="formData.phone"
                    disabled
                    placeholder="居民身份证号码/手机号码/用户名" size="large" prefix-icon="Cellphone" />
        </el-form-item>

        <el-form-item prop="password" :rules="[{ required: true, message: '请输入个人用户密码', trigger: 'change' }]">
          <el-input v-model.trim="formData.password"
                    disabled
                    type="password" show-password placeholder="个人用户密码" size="large" prefix-icon="Lock" />
        </el-form-item>

        <el-form-item prop="dragVerify" :rules="[{ validator: (rule, value, callback) => value == true, message: '请按住滑块，拖动到最右边', trigger: ['change', 'blur'] }]">
          <dragVerify v-model="formData.dragVerify" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="large" style="width: 100%" @click="login">登录</el-button>
        </el-form-item>

        <div class="form-footer" v-if="formData.loginType == 1">
          <div class="form-footer-btn">
            <el-button link type="primary">找回手机号码</el-button>
            <el-button link type="primary">忘记密码</el-button>
          </div>

          <div class="form-footer-other">
            <p>其他登录</p>
          </div>

          <div class="form-footer-login">
            <el-button link type="primary">
              <svg data-v-462d3aeb="" xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 22" fill="none">
                <g data-v-462d3aeb="" id="aspjdaps3">
                  <path
                    data-v-462d3aeb=""
                    id="Vector"
                    d="M17.2948 3H4.7052C3.21116 3 2 4.19065 2 5.6594V16.3406C2 17.8093 3.21116 19 4.7052 19H17.2948C18.7888 19 20 17.8093 20 16.3406V5.6594C20 4.19065 18.7888 3 17.2948 3Z"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_2"
                    d="M11.0009 6L12.5458 9.29203L16 9.82005L13.5014 12.382L14.0907 16L11.0009 14.2901L7.91115 16L8.50045 12.382L6 9.82005L9.45603 9.29203L11.0009 6Z"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
              特定主体登录
            </el-button>
            <el-button link type="primary">
              <svg data-v-462d3aeb="" xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 23" fill="none">
                <g data-v-462d3aeb="" id="oiudsndd1">
                  <path
                    data-v-462d3aeb=""
                    id="Vector"
                    d="M8.96769 20H2.36433C2.2677 20 2.17503 19.962 2.10671 19.8944C2.03839 19.8267 2 19.735 2 19.6393V2.3607C2 2.26504 2.03839 2.17329 2.10671 2.10565C2.17503 2.038 2.2677 2 2.36433 2H11.6357C11.6835 2 11.7309 2.00933 11.7751 2.02745C11.8193 2.04558 11.8595 2.07215 11.8933 2.10565C11.9271 2.13914 11.954 2.1789 11.9723 2.22266C11.9906 2.26642 12 2.31333 12 2.3607V8.83921"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_2"
                    d="M12 7H19.6367C19.7329 7.00039 19.8251 7.03599 19.8931 7.09907C19.9612 7.16214 19.9996 7.24757 20 7.33676V9"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_3"
                    d="M16 17C17.6569 17 19 15.6569 19 14C19 12.3431 17.6569 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17Z"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_4"
                    d="M19.9999 20C20.0003 19.6284 19.9121 19.2605 19.7405 18.9173C19.6228 18.6818 19.4673 18.4611 19.2788 18.261"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_5"
                    d="M12 20C12 19.2043 12.4214 18.4413 13.1716 17.8787C13.9217 17.3161 14.9391 17 16 17"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path data-v-462d3aeb="" id="Vector_6" d="M5 5H7" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path data-v-462d3aeb="" id="Vector_7" d="M5 10H8" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path data-v-462d3aeb="" id="Vector_8" d="M5 14H10" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
              非居民企业登录
            </el-button>
          </div>
        </div>

        <div class="form-footer form-footer-2" v-if="formData.loginType == 2">
          <div class="form-footer-btn">
            <el-button link type="primary">用户注册</el-button>
            <el-button link type="primary">找回手机号码</el-button>
            <el-button link type="primary">忘记密码</el-button>
          </div>

          <div class="form-footer-other">
            <p>其他登录</p>
          </div>

          <div class="form-footer-login">
            <el-button link type="primary">
              <svg data-v-462d3aeb="" xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 23" fill="none">
                <g data-v-462d3aeb="" id="oiudsndd1">
                  <path
                    data-v-462d3aeb=""
                    id="Vector"
                    d="M8.96769 20H2.36433C2.2677 20 2.17503 19.962 2.10671 19.8944C2.03839 19.8267 2 19.735 2 19.6393V2.3607C2 2.26504 2.03839 2.17329 2.10671 2.10565C2.17503 2.038 2.2677 2 2.36433 2H11.6357C11.6835 2 11.7309 2.00933 11.7751 2.02745C11.8193 2.04558 11.8595 2.07215 11.8933 2.10565C11.9271 2.13914 11.954 2.1789 11.9723 2.22266C11.9906 2.26642 12 2.31333 12 2.3607V8.83921"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_2"
                    d="M12 7H19.6367C19.7329 7.00039 19.8251 7.03599 19.8931 7.09907C19.9612 7.16214 19.9996 7.24757 20 7.33676V9"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_3"
                    d="M16 17C17.6569 17 19 15.6569 19 14C19 12.3431 17.6569 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17Z"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_4"
                    d="M19.9999 20C20.0003 19.6284 19.9121 19.2605 19.7405 18.9173C19.6228 18.6818 19.4673 18.4611 19.2788 18.261"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-462d3aeb=""
                    id="Vector_5"
                    d="M12 20C12 19.2043 12.4214 18.4413 13.1716 17.8787C13.9217 17.3161 14.9391 17 16 17"
                    stroke="#4285F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path data-v-462d3aeb="" id="Vector_6" d="M5 5H7" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path data-v-462d3aeb="" id="Vector_7" d="M5 10H8" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path data-v-462d3aeb="" id="Vector_8" d="M5 14H10" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
              境外自然人登录
            </el-button>
          </div>
        </div>

        <div class="form-footer" v-if="formData.loginType == 3">
          <div class="form-footer-btn">
            <el-button link type="primary">找回手机号码</el-button>
            <el-button link type="primary">忘记密码</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <div class="login-form-r" v-if="false">
      <div style="width: 100%; display: inline-flex; justify-content: space-between">
        <el-button type="primary" text>找回手机号</el-button>
        <el-button type="primary" text>找回密码</el-button>
      </div>

      <div style="width: 100%">
        <img src="https://static.rhkj.com/renhe_fe/other/stateTax/other-login.png" alt="#" style="width: 100%; object-fit: contain" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import dragVerify from "./dragVerify.vue";

const emits = defineEmits(["loginSuccess"]);

const formRef = ref(null);
const formData = ref({
  loginType: 1,
  taxRegistrationNo: "91110104533585261H",
  phone: "17589743064",
  password: "123456",
  dragVerify: true,
});

onMounted(() => {});

const loginTypeChange = ({ value }) => {
  if (formData.value.loginType == value) {
    return;
  }

  formRef.value.resetFields();
  formData.value.loginType = value;
  if (value == 1 || value == 3) {
    formData.value.phone = '17589743064';
  } else {
    formData.value.phone = '13500100001'
  }
};

const currentQa = inject('provideCurrentQa');

const loginTypeOptions = [
  { value: 1, label: "企业业务" },
  { value: 2, label: "自然人业务" },
  { value: 3, label: "代理业务" },
];

//点击登录按钮跳转至套餐业务页面
const login = async () => {
  await formRef.value.validate((valid) => {
    if (valid) {
      emits("loginSuccess");
      sessionStorage.setItem('digTaxLoginType_' + currentQa.value.queId, formData.value.loginType)
    }
  });
};
</script>

<style lang="scss" scoped>
.login-form {
  position: relative;
  box-sizing: border-box;
  width: 852px;
  height: 575px;
  padding: 46px 0;
  background-color: #ffffff;
  display: flex;

  .login-form-l {
    width: 370px;
    flex: 0 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 1px;
      height: 480px;
      background: #ddd;
      border-radius: 1px 0 0 1px;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .tip {
      font-size: 20px;
      color: #333;
      text-align: center;
      margin-bottom: 78px;

      span {
        color: rgb(66, 133, 244);
        font-weight: bold;
        font-size: 23px;
        border-bottom: 3px solid rgb(66, 133, 244);
      }
    }

    .qrcode {
      width: 200px;
      height: 200px;
      border: 1px solid #e7e7e7;
      width: 200px;
      height: 200px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-bottom: 75px;

      &::before {
        position: absolute;
        content: "";
        width: 60px;
        height: 60px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABJZJREFUaEPtm1tIFGEUx/8zs6u7aok3MkPLLloh2U3QoiAKKjLCKCgkC7pQ9lI9KPTQQ0RQEEVQFHSnKCioSKKCogtRPXShosgMLQszNdQ03cvMxDfbuOPszuw4u+M663wvi+7ofL/vnPM/5zvfDMXz/DIA5wCkI7ZHK4ANFM/zLcMAVjRlKwHmyU/PPntxsMaFzp7YMvNIJ1BV6kDJJEYA6wMuO9wdc7Ci6UY6KVzfmdAfeOH+7tgyrYzm/u5EC9iycCytgOXSkRYthgKy0ylMHEUjL5PBuAwaSQ6g8myv4Djiisu9aM+1XjytZQOca/E0G6pK4wN+/7OdQ/nx0Lk0ohZOjAdyM2gBbgIBHE0jJ41GnI3qN0Hp5EwDnD6CQv5oWrCYCDgmhdYU7qYDPrXZKVhS79ACfPSuCzdfegNusabEjs0L4gbXpS9tdyIz2Vhgt5fHtzYOZx558KKORekMG5bPtAkLzdD9Q4TQGxrDkQS+uSsBSY5AANGEB265cO+dFxXz7Fg/L9Cy4nX1vzhsOmWQaOkB7urlUdfM4Uszhw8/WDz86FPgcek0slKVgcn1zR08stMoZKcpe1VtE4fWP8L+R3XoUmmtwJ+aWFx86hEgyaSHwggLmOV41Lf4rEasVzzRhlm5vu0XGXffenCwxq3KGSyn6lmYjr88Tj5Qv5c07/dtD7UUHnPyGDS3c6hv4cFJDEcmTwoDJWCSynLSKGSl0Kh57VNgpTw8UGhDRUtpMnJgEquvGlhMyWKEXJ2c4ItVLWlpyALbbUB+Ji2kixWz7Zrys+mAVxbZMHUMI5SOmclU0LyoZiE1YNJi6uwJLXAkPGbl+sPHUJfWqtJK0GrAW073CCIYaszNY7B3laPvMgtYYcXCSkuhrBDse5LK3nxlUXXZFVSlTW3hHre/uiJ5uraJxbc2Hh7JNleelkwD3NLJCeKVmuQvE7UUHqYA3rc6Ht0ugJSOYqVFGvehCo9gLi4Hrr7Si8a20KJVNJ7BzqX+zoehoqW18NBjYT26IC9m1P6HLtHSAzwqmcL0sQwKc2gUjmVQfsy3lYup0lJqYTmYWLObAlgsJwuyicUYXH3hxqsGTjWGTQ18YZsT0oad2FJVEy0lYOLqSmPrwjjMn+wvHx9/9OKEwhaQ5TB4DYBwgNUERo/qhxI9XaIlr6XDAT650V8Pk8nuu+FCY5tv8xCTwGqFhwUsaRlNyaKxdo69z4N/d/E4csegFk8kXVqvhaO6PQwnhi1gSQNALYYtCxt5XGrF8P/Daz2VlhXDVgwHP8kYNqJ1/olHOMUgm4pFBVHqSw9WHtba3I94xyNaKm0BS1bgx28OFScMegLgyDoHMkb4N+6Hbrsi1vGQ9qXlaU7kIy1h8WkC4fMXh5/t/Y9ulbxB135YTxNPa4tHCrxjSZxwYEfOmqQH76RFrHdEFFiLWIjXKDXxtJ48mBb4UqUT776zeN/I4X0ji4bW0EelemGlbeEBPfIQzg2j/beD5tLRBhXvbwGXHf6r6ZGDoWKxgcwj6Esezz97caDGHXPQBLa6NB7Fktd4ht2LWsPqVbx/0ILLCBekV/MAAAAASUVORK5CYII=)
          no-repeat;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
      }
    }

    .btn {
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }

  .login-form-r {
    width: 100%;
    overflow: hidden;

    .tab {
      padding: 0 4px;
      display: flex;
      font-size: 16px;
      color: #666666;
      text-align: center;
      line-height: 48px;
      margin-top: -5px;
      margin-bottom: 20px;

      > li {
        flex: 1;
        position: relative;
        cursor: pointer;

        &::before {
          position: absolute;
          content: "";
          width: 100%;
          height: 4px;
          background: #4285f4;
          border-radius: 2px;
          left: 0;
          bottom: 0;
          display: none;
        }

        &.is-active {
          font-weight: bold;
          color: #000000;

          &::before {
            display: block;
          }
        }
      }
    }

    .form-box {
      padding: 0 32px;
    }

    .form-footer {
      &.form-footer-2 {
        .form-footer-other {
          margin-top: 110px;
        }
      }

      .form-footer-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .form-footer-other {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;

        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          background-color: #dcdfe6;
        }

        p {
          font-size: 14px;
          color: #303133;
          padding: 0 20px;
          background-color: #ffffff;
          position: relative;
          z-index: 2;
        }
      }

      .form-footer-login {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
      }
    }
  }
}
</style>
